import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

// Containers
const PortalContainer = () => import("../containers/PortalContainer");
const PortalContainerVertical = () =>
  import("../containers/PortalContainerVertical.vue");

// Views - Pages
const Page401 = () => import("../views/pages/UnauthorizedPage");
const Page404 = () => import("../views/pages/NotFoundPage");

// Views - Pages - Company
const CompanyHome = () => import("../views/pages/company/CompanyHome");
const CompanyHomeVertical = () =>
  import("../views/pages/company/CompanyHomeVertical");
const CompanyComplaintDelegate = () =>
  import("../views/pages/company/CompanyComplaintDelegate");
const FollowProtocol = () => import("../views/pages/company/FollowProtocol");
const CompanyQaS = () => import("../views/pages/company/CompanyQaS");
const CompanyDSAR = () => import("../views/pages/company/CompanyDSAR");
const CompanyOmbudsman = () =>
  import("../views/pages/company/CompanyOmbudsman");
const NR1Questionnaire = () =>
  import("../views/pages/company/NR1Questionnaire");
const Task = () => import("../views/pages/company/CompanyTask");
const OmbudsmanTask = () =>
  import("../views/pages/company/CompanyOmbudsmanTask");
import { Routes } from "@/i18n";

Vue.use(Router);

function getRoutePaths(path, alt = false, suffix = "") {
  const routes = Routes[`${path}${alt ? "Alt" : ""}`];
  if (routes) {
    return {
      path: `${path}${suffix}`,
      alias: Object.values(routes)
        .filter((route) => route !== path)
        .map((route) => `${route}${suffix}`),
    };
  }
  return {
    path,
  };
}

const whitelabelPortalMap = {
  martinelli: () => import("../containers/whitelabel/MartinelliContainer.vue"),
  gestione: () => import("../containers/whitelabel/GestioneContainer.vue"),
};

const whitelabelHomeMap = {
  martinelli: () =>
    import("../views/pages/whitelabel/martinelli/CompanyHome.vue"),
  gestione: () => import("../views/pages/whitelabel/gestione/CompanyHome.vue"),
};

export function getRoutes() {
  const complaintAltForm =
    store.getters["company"]?.modules?.complaint?.alternateForm;
  const verticalLayout = store.getters["portal"]?.layout === "vertical";
  const whitelabel = store.getters["portal"]?.whitelabel;

  const layoutContainer = whitelabel
    ? whitelabelPortalMap[whitelabel]
    : verticalLayout
    ? PortalContainerVertical
    : PortalContainer;
  const homeView = whitelabel
    ? whitelabelHomeMap[whitelabel]
    : verticalLayout
    ? CompanyHomeVertical
    : CompanyHome;

  return [
    // NR1 Questionnaire - rota para acesso direto via QR code (DEVE vir antes da rota raiz)
    {
      path: "/nr1/questionnaire/:id",
      component: layoutContainer,
      hidden: true,
      children: [
        {
          path: "",
          name: "NR1 Questionnaire Direct",
          hidden: true,
          component: NR1Questionnaire,
          props: true,
          meta: {
            module: "nr1",
            layout: {
              sidebar: false,
            },
          },
        },
      ],
    },
    // Rotas principais com layout
    {
      path: "/",
      redirect: "/home",
      component: layoutContainer,
      children: [
        {
          ...getRoutePaths("home"),
          name: "Home",
          component: homeView,
          meta: {
            icon: "fas fa-home",
          },
        },
        {
          ...getRoutePaths("report", complaintAltForm),
          name: "Report",
          component: CompanyComplaintDelegate,
          meta: {
            icon: "fas fa-file-alt",
            module: "complaint",
            verticalHidden: true,
          },
        },
        {
          ...getRoutePaths("data-subject-access-request"),
          name: "Data Subject Access Request",
          component: CompanyDSAR,
          meta: {
            icon: "fas fa-id-card",
            module: "dsar",
            verticalHidden: true,
          },
        },
        {
          ...getRoutePaths("questions-and-suggestions"),
          name: "Questions and Suggestions",
          component: CompanyQaS,
          meta: {
            icon: "fas fa-question",
            module: "qas",
            verticalHidden: true,
          },
        },
        {
          ...getRoutePaths("ombudsman"),
          name: "Ombudsman",
          component: CompanyOmbudsman,
          meta: {
            icon: "fa fa-user-tie",
            module: "ombudsman",
            verticalHidden: true,
          },
        },
        {
          ...getRoutePaths("follow-up"),
          name: "Follow up",
          component: FollowProtocol,
          meta: {
            icon: "fas fa-eye",
          },
        },
        {
          ...getRoutePaths("follow-up", false, "/:protocol"),
          name: "Follow up Protocol",
          hidden: true,
          props: true,
          component: FollowProtocol,
        },
        {
          path: "task/:token",
          name: "Task",
          hidden: true,
          props: true,
          component: Task,
          meta: {
            layout: {
              sidebar: false,
            },
          },
        },
        {
          path: "ombudsman-task/:token",
          name: "Ombudsman Task",
          hidden: true,
          props: true,
          component: OmbudsmanTask,
          meta: {
            layout: {
              sidebar: false,
            },
          },
        },
        {
          path: "nr1/questionnaire/:id",
          name: "NR1 Questionnaire",
          hidden: true,
          props: true,
          component: NR1Questionnaire,
          meta: {
            module: "nr1",
            layout: {
              sidebar: false,
            },
          },
        },
      ],
    },
    // modals
    {
      path: "/channel-video",
      meta: {
        modal: "channel-video",
      },
      hidden: true,
    },
    // errors
    { path: "/404", component: Page404, hidden: true },
    { path: "/401", component: Page401, hidden: true },
    { path: "*", redirect: "/404", hidden: true },
  ];
}
let router;
function initRouter() {
  if (!router) {
    router = new Router({
      mode: "hash", // https://router.vuejs.org/api/#mode
      linkActiveClass: "open active",
      scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
          const el = document.getElementById(to.hash.slice(1));
          if (el) {
            window.scrollTo(0, el.offsetTop);
          }
          return {
            el: to.hash,
          };
        } else if (savedPosition) {
          return savedPosition;
        } else {
          return { y: 0 };
        }
      },
      routes: getRoutes(),
    });
    router.beforeEach((to, from, next) => {
      if (store.getters["portal"].whitelabel === "martinelli") {
        if (to.redirectedFrom === "/ajuda") {
          return next({ path: "/home", hash: "#ajuda" });
        }
      }
      return next();
    });
  }
  return router;
}
export { router, initRouter };
